// extracted by css-extract-rspack-plugin
export default {"wrapper":"_520a7d3a","headerBackground":"_a5dc1998","barHeader":"_24f20be7"};